import { FC, useEffect } from 'react';
import { DateTime } from 'luxon';
import { Backdrop, CircularProgress, Modal } from '@mui/material';
import ModalAction from 'src/components/Items/Actions';
import { useActions } from 'src/hooks/useActions';
import { useTypedSelector } from 'src/hooks/useTypeSelector';
import './styles.scss';
import './media.scss';

interface IProps {
  orderId: number;
  price: string;
  startDate: string;
  card?: string;
  open: boolean;
  handleClose: () => void;
}
const PayConfirmModal: FC<IProps> = ({ orderId, price, startDate, card, handleClose, open }) => {
  const { payNow, clearClientResult } = useActions();
  const { isLoading, result } = useTypedSelector(state => state.client);

  useEffect(() => {
    if (result.pay) {
      handleClose();
      clearClientResult();
    }
  }, [result.pay]);

  const handleSubmit = () => {
    payNow(orderId, DateTime.now().toISO() < startDate ? 'due_payment' : 'afterCharge_payment');
  };

  return (
    <Modal open={open} closeAfterTransition BackdropComponent={Backdrop} onClose={handleClose}>
      <div className='payment-modal'>
        <div className='payment-modal__title'>
          {isLoading.pay ? 'Payment in progress...' : 'Confirm payment'}
        </div>
        {card && card.length && (
          <div className='payments-card__title'>Your card is on file **{card}</div>
        )}
        <div>
          <span className='payments-card__title'>Open Balance:</span>
          <span className='payments-card__price red'>{price}</span>
        </div>
        {isLoading.pay ? (
          <CircularProgress size={30} sx={{ mt: 3 }} />
        ) : (
          <ModalAction
            type='Now'
            action='Settle'
            handleClose={handleClose}
            handleSubmit={handleSubmit}
          />
        )}
      </div>
    </Modal>
  );
};
export default PayConfirmModal;
